module.exports = ".yeti-button-positive {\n  min-width: 70px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/reusable-components/edit-quote-warning/edit-quote-warning.component.scss
// module id = 632
// module chunks = 0